import clsx from 'clsx';
import React from 'react';
import styles from './TimerIcon.module.scss';

type Props = {
    warning: boolean;
};

const TimerIcon: React.FC<Props> = ({ warning }) => (
    <svg
        width="22"
        height="24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={styles.icon}
    >
        <path
            className={clsx(styles.path, warning && styles.warning)}
            d="M18.822 7.377l.94-.94a.936.936 0 00-1.323-1.325l-.941.941a10.047 10.047 0 00-5.544-2.296V1.873h.905a.936.936 0 000-1.873H9.177a.936.936 0 100 1.873h.905v1.884c-5.123.466-9.207 4.77-9.207 10.1A10.137 10.137 0 0011.018 24a10.137 10.137 0 0010.143-10.143c0-2.395-.825-4.663-2.34-6.48zm-7.804 14.75c-4.56 0-8.27-3.71-8.27-8.27s3.71-8.27 8.27-8.27 8.27 3.71 8.27 8.27-3.71 8.27-8.27 8.27zm4.339-12.609a.936.936 0 010 1.324l-3.677 3.677a.936.936 0 01-1.324-1.324l3.677-3.677a.936.936 0 011.324 0z"
        />
    </svg>
);
export default TimerIcon;
